'use client';
import { jsx } from 'react/jsx-runtime';
import { mergeProps } from '@zag-js/react';
import { forwardRef } from 'react';
import { createSplitProps } from '../create-split-props.mjs';
import { ark } from '../factory.mjs';
import '../presence/index.mjs';
import { runIfFn } from '../run-if-fn.mjs';
import { SelectProvider } from './select-context.mjs';
import { useSelect } from './use-select.mjs';
import { splitPresenceProps } from '../presence/split-presence-props.mjs';
import { usePresence } from '../presence/use-presence.mjs';
import { PresenceProvider } from '../presence/presence-context.mjs';

const SelectImpl = (props, ref) => {
  const [presenceProps, selectProps] = splitPresenceProps(props);
  const [useSelectProps, { children, ...localProps }] = createSplitProps()(
    selectProps,
    [
      "closeOnSelect",
      "defaultValue",
      "dir",
      "disabled",
      "form",
      "getRootNode",
      "highlightedValue",
      "id",
      "ids",
      "invalid",
      "isItemDisabled",
      "items",
      "itemToString",
      "itemToValue",
      "loop",
      "multiple",
      "name",
      "onFocusOutside",
      "onHighlightChange",
      "onInteractOutside",
      "onOpenChange",
      "onPointerDownOutside",
      "onValueChange",
      "open",
      "positioning",
      "readOnly",
      "selectOnBlur",
      "value"
    ]
  );
  const api = useSelect(useSelectProps);
  const presenceApi = usePresence(mergeProps({ present: api.isOpen }, presenceProps));
  const view = runIfFn(children, api);
  const mergedProps = mergeProps(api.rootProps, localProps);
  return /* @__PURE__ */ jsx(SelectProvider, { value: api, children: /* @__PURE__ */ jsx(PresenceProvider, { value: presenceApi, children: /* @__PURE__ */ jsx(ark.div, { ...mergedProps, ref, children: view }) }) });
};
const Select = forwardRef(SelectImpl);

export { Select };
